import type { Translations } from "../types";

const sw: Translations = {
  "meta.title": "Ramani ya Mibofyo kwa Nchi",
  "meta.description":
    "Ramani ya dunia inayoingiliana: mibofyo ya bure kwa kila nchi pamoja na msaada wa kulipia kupitia Stripe, PayPal na Buy Me a Coffee.",

  "app.title": "Ramani ya Mibofyo kwa Nchi",

  "map.intro":
    "Bofya nchi kwenye ramani ili kuipa kura ya bure, au itumie msaada wa kifedha - vyote viwili vinahesabiwa kwenye ubao wa matokeo ulioungana hapa chini. Ramani inaonyesha tu msaada ndani ya programu hii, si utajiri halisi wa taifa au Pato la Taifa.",
  "map.verifying": "Inathibitisha …",
  "map.confirmNotRobot": "Kabla hujaongeza mibofyo ya bure, thibitisha haraka kuwa wewe si roboti:",
  "map.tryAgain": "Jaribu tena",
  "map.registeringClick": "Inasajili mbofyo …",
  "map.selectedCountry": "Nchi iliyochaguliwa: {name}.",
  "map.selectFirstFeedback": "Nchi imechaguliwa. Ili kuongeza mbofyo wa bure, kwanza thibitisha hapa chini kuwa wewe si roboti.",
  "map.verificationExpired": "Uthibitisho umeisha muda - thibitisha tena kuwa wewe si roboti.",
  "map.slowDown": "Punguza kasi kidogo - subiri kidogo kabla ya mbofyo wako unaofuata.",
  "map.clickFailed": "Imeshindwa kusajili mbofyo. Tafadhali jaribu tena.",
  "map.clickErrorGeneric": "Hitilafu katika kusajili mbofyo.",
  "map.leaderboardHeading": "Ubao wa Matokeo wa Nchi",
  "map.emptySelection": "Chagua nchi kwenye ramani ili kuibofya au kuisaidia.",
  "map.loadingData": "Inapakia data …",

  "worldmap.loadError": "Imeshindwa kupakia ramani.",
  "worldmap.resetZoom": "Rejesha ukuzaji",
  "worldmap.resetButton": "⤾ Rejesha",
  "worldmap.loadingMap": "Inapakia ramani …",
  "worldmap.unknownCountry": "Haijulikani",
  "worldmap.ariaClicks": "{name}: mibofyo {clicks}",
  "worldmap.tooltipClicks": "Mibofyo {clicks}",

  "legend.fewer": "Mibofyo michache",
  "legend.more": "Mibofyo mingi",

  "list.empty": "Bado hakuna mibofyo. Kuwa wa kwanza!",
  "list.ariaLabel": "Ubao wa matokeo wa nchi kwa mibofyo",

  "human.siteKeyMissing": "VITE_TURNSTILE_SITE_KEY haijawekwa - angalia README kwa usanidi.",
  "human.verificationFailedGeneric": "Uthibitisho umeshindwa.",
  "human.networkError":
    "Imeshindwa kufikia uthibitisho (hitilafu ya mtandao) - angalia VITE_SUPABASE_URL, kwamba verify-human imesambazwa, na ALLOWED_ORIGIN; angalia README/NAVODILA.",
  "human.verificationFailedRetry": "Uthibitisho umeshindwa, jaribu tena.",

  "provider.stripe": "💳 Kadi (Stripe)",
  "provider.paypal": "🅿️ PayPal",
  "provider.buymeacoffee": "☕ Buy Me a Coffee",

  "panel.selectedCountryLabel": "Nchi iliyochaguliwa",
  "panel.currentlyRanked": "Kwa sasa iko nafasi ya #{rank}",
  "panel.shareCopied": "Imenakiliwa ✓",
  "panel.shareShared": "Imeshirikiwa ✓",
  "panel.shareButton": "🔗 Shiriki",

  "panel.tableClicks": "Mibofyo",
  "panel.tableFree": "Bure",
  "panel.tablePaid": "Iliyolipiwa",
  "panel.rowAllTime": "Wakati wote",
  "panel.rowThisYear": "Mwaka huu",
  "panel.rowThisWeek": "Wiki hii",
  "panel.rowToday": "Leo",

  "panel.totalCombined": "Jumla iliyounganishwa:",
  "panel.totalSupport": "Jumla ya msaada:",

  "panel.paymentMethod": "Njia ya malipo",
  "panel.noPaymentMethod": "Hakuna njia ya malipo inayopatikana kwa sasa.",
  "panel.supportAmount": "Kiasi cha msaada (EUR)",
  "panel.amountRange": "Kiasi kinapaswa kuwa kati ya {min} na {max}.",
  "panel.quickAmount": "€{eur}",
  "panel.estimatedClicks": "Mibofyo ya kulipiwa inayokadiriwa:",
  "panel.ratioInfo":
    "Uwiano: {a} = mibofyo {b} (mfano {c} = mibofyo {d}). Hii ni makadirio tu kabla ya malipo - idadi ya mwisho ya mibofyo daima huhesabiwa na kuthibitishwa na seva kulingana na malipo yaliyothibitishwa kikamilifu.",
  "panel.preparing": "Inaandaa …",
  "panel.continueWith": "Endelea na {provider}",
  "panel.choosePaymentMethod": "Chagua njia ya malipo",
  "panel.bmcUsernameMissing": "VITE_BMC_USERNAME haijawekwa - angalia README kwa usanidi.",
  "panel.paypalClientIdMissing": "VITE_PAYPAL_CLIENT_ID haijawekwa - angalia README kwa usanidi.",

  "panel.paypalAmountInfo": "Kiasi: {amount} (mibofyo {clicks} inayokadiriwa). Kamilisha malipo kwa kutumia kitufe cha PayPal hapa chini.",
  "panel.back": "← Rudi",

  "panel.bmcWarningTitle": "⚠️ Kabla ya kuendelea kwenda BuyMeCoffee:",
  "panel.bmcWarningBody":
    "Bandika msimbo ulio hapa chini kwenye sehemu ya ujumbe/maelezo wakati wa malipo — hiyo ndiyo njia pekee tutakayojua ni nchi gani unayoisaidia. Bila msimbo, hatuwezi kuhusisha malipo na nchi yoyote.",
  "panel.copy": "Nakili",
  "panel.copied": "Imenakiliwa ✓",
  "panel.suggestedAmount": "Kiasi kinachopendekezwa:",
  "panel.bmcAmountNote":
    "(mibofyo {clicks} inayokadiriwa). Kwa bahati mbaya BuyMeCoffee haiwezi kubeba kiasi kupitia kiungo — kiingize/kichague mwenyewe kwenye tovuti yao. Idadi halisi ya mibofyo daima huhesabiwa kutoka kiasi unachotuma kwa kweli kwenye BuyMeCoffee, si kutoka makadirio haya.",
  "panel.openBmc": "Fungua BuyMeCoffee na uendelee →",
  "panel.waitingProvider": "Inasubiri uthibitisho wa malipo kutoka kwa mtoa huduma wa malipo …",
  "panel.waitingConfirmation": "Inasubiri uthibitisho wa malipo …",
  "panel.timedOut":
    "Ukaguzi umechukua muda mrefu. Ikiwa umekamilisha malipo, ramani itasasishwa mara seva itakapopokea uthibitisho - hii wakati mwingine inaweza kuchukua muda kidogo zaidi.",
  "panel.checkAgain": "Kagua tena",

  "panel.cancelled": "Malipo yalighairiwa au hayakukamilika. Ramani haijabadilika.",
  "panel.tryAgain": "Jaribu tena",

  "panel.confirmed": "✅ Msaada umethibitishwa!",
  "panel.confirmedBody": "{country} imepokea mibofyo {clicks} iliyolipiwa kwa {amount}.",

  "panel.errorPreparingSupport": "Hitilafu katika kuandaa msaada wako.",
  "panel.errorPreparingPayment": "Hitilafu katika kuandaa malipo.",
  "panel.errorConfirmingPayment": "Hitilafu katika kuthibitisha malipo.",
  "panel.errorPayingPaypal": "Hitilafu katika kulipa kwa PayPal.",

  "share.unranked": "{flag}{country} inahitaji msaada wako kwenye ramani ya dunia!\nSaidia ipande katika ubao wa matokeo 👇",
  "share.rank1": "{flag}{country} kwa sasa iko nafasi ya #1!\nTusaidie kubaki juu 👇",
  "share.rankN": "{flag}{country} kwa sasa iko nafasi ya #{rank}!\nTusaidie kufika #1 👇",

  "language.switcherLabel": "Lugha",
};

export default sw;
